import { 
    GET_REG_COMPANY_INVITATIONS, 
    USER_LOADING, USER_LOADED, 
    AUTH_ERROR, 
    LOGIN_SUCCESS, 
    VERIFY_SUCCESS, 
    LOGIN_FAIL, 
    LOGOUT_SUCCESS, 
    LOGOUT_FAIL, 
    REGISTER_SUCCESS, 
    REGISTER_FAIL, 
    CLEAR_REGISTRATION, 
    ACTIVATE_SUCCESS, 
    ACTIVATE_FAIL, 
    EDIT_USER,
    USER_LOAD_CANCELED,
    GET_JOIN_CO_REQUEST_COUNT,
    EXTERNAL_ACTION,
    GET_INVITE_DETAIL
} from "../actions/types";

const initialState = {
	token: localStorage.getItem("token"),
    status: null,
    isCompanyDomainUnique: null,
	user: null,
    externalAction: null,
    inviteDetail: null
}

export default function(state = initialState, action) {
	switch(action.type) {
		case GET_INVITE_DETAIL:
			return {
				...state,
				inviteDetail: action.payload
			}
		case USER_LOADING:
			return {
				...state,
				status: "loading"
			}
		case USER_LOADED:
			return { 
				...state,
				status: "authenticated",
				user: action.payload
			}
		case EDIT_USER:
			return { 
				...state,
				user: {...state.user, ...action.payload},
			}
		case LOGIN_SUCCESS:
			localStorage.setItem("token", action.payload.token);
            localStorage.setItem("logged_in", true);
			return {
				...state,
				...action.payload,
                status: "authenticated"
			}
		case REGISTER_SUCCESS:
			return {
				...state,
				status: action.payload.reg_complete === true ? "registrationComplete" : "registering",
				isCompanyDomainUnique: action.payload.domain_unique === true,
			}
		case CLEAR_REGISTRATION:
			return {
				...initialState,
			}
		case ACTIVATE_SUCCESS:
			return {
				...state,
				status: "activated",
			}
        case LOGOUT_SUCCESS:
            localStorage.removeItem("logged_in");
            localStorage.removeItem("token");
            return {
                ...initialState,
            }
		case ACTIVATE_FAIL:
			return {
				...state,
                status: "activateFailed",
			}
		case LOGIN_FAIL:
            localStorage.removeItem("logged_in");
            return {
				...state,
				status: "loginfail",
			}
		case AUTH_ERROR:
            localStorage.removeItem("token");
            localStorage.removeItem("logged_in");
            return {
				status: "authError",
			}
        case REGISTER_FAIL:            
			return {
				...state,
				status: "registrationFailed",
			}
		case VERIFY_SUCCESS:
			return {
				...state,
				status: "verified"
			}
        case USER_LOAD_CANCELED:
            localStorage.removeItem("token");
            localStorage.removeItem("logged_in");
			return {
                ...initialState,
			}
		case LOGOUT_FAIL:
			localStorage.removeItem("token");
            localStorage.removeItem("logged_in");
			return {
                ...initialState,
			}
        case EXTERNAL_ACTION:
            return {
                ...initialState,
                externalAction: {...action.payload}
			}
		default:
			return state;
	}
}